export default "__VITE_ASSET__ByvK_Pkl__"